/**
 * @generated SignedSource<<9de9165fe590b507861495717b4990e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ImageMultiSkuOverlay_item$data = {
  readonly ImageMultiSkuOverlayImageSrc: string | null;
  readonly isMultiSku: boolean;
  readonly isRingItem: boolean | null;
  readonly " $fragmentType": "ImageMultiSkuOverlay_item";
};
export type ImageMultiSkuOverlay_item$key = {
  readonly " $data"?: ImageMultiSkuOverlay_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ImageMultiSkuOverlay_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "large",
      "kind": "LocalArgument",
      "name": "imageSize"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ImageMultiSkuOverlay_item",
  "selections": [
    {
      "alias": "ImageMultiSkuOverlayImageSrc",
      "args": [
        {
          "kind": "Variable",
          "name": "size",
          "variableName": "imageSize"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMultiSku",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRingItem",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "5b0fc50ba30c6a5da4e594425af08603";

export default node;
